<template>
  <div class="content container-fluid">
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{ $route.params.id ? "Edit Dependent" : "New Dependent" }}
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="save">
      <div class="form-group row align-items-center">
        <label v-if="role == 'admin'" class="col-md-3 mb-0">Employee Name (Emp ID)</label>
        <label v-else class="col-md-3">Employee Name (Emp ID)</label>
        <div class="col-md-7 pl-md-0">
          <Select2
            v-model="userId"
            :options="employees"
            v-if="role == 'admin'"
            required
          />
          <span v-else>{{ employees.length ? employees[0].text : this.loadingName }}</span>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Insurance Year</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="year" required v-if="!this.isNewEmployee">
            <option value="">-- Please Select --</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>

          <span v-if="this.isNewEmployee">{{ this.year }}</span>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Dependent Name</label>
        <div class="col-md-7 pl-md-0">
          <select
            class="custom-select"
            v-model="name"
            @change="onChangeDependentName($event)"
            required
          >
            <option value="">-- Please Select --</option>
            <option v-for="(item, i) in names" :key="i" :value="item.Name">
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Dependent IC Number</label>
        <div class="col-md-7 pl-md-0">
          <!--<input
            type="text"
            class="form-control"
            v-model="ic"
            maxlength="100"
            required
          />-->
          <span class="label">{{ ic }}</span>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Dependent Nationality</label>
        <div class="col-md-7 pl-md-0">
          <!--<input
            type="text"
            class="form-control"
            v-model="nationality"
            maxlength="500"
            required
          />-->
          <span class="label">{{ nationality }}</span>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Dependent Gender</label>
        <div class="col-md-7 pl-md-0">
          <!--<select class="custom-select" v-model="gender" required>
            <option value="">-- Please Select --</option>
            <option value="F">Female</option>
            <option value="M">Male</option>
          </select>-->

          <span class="label">{{ gender == "F" ? "Female" : (gender == "M" ? "Male" : "") }}</span>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Dependent Birthday</label>
        <div class="col-md-7 pl-md-0">
          <!--<input type="date" class="form-control" required v-model="birthday" />-->
          <span class="label">{{ birthdayDisplay }}</span>
        </div>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Dependent Marital Status</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="maritalStatus" required>
            <option value="">-- Please Select --</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Widowed">Widowed</option>
            <option value="Divorced">Divorced</option>
            <option value="Partnership">Partnership</option>
            <option value="Separated">Separated</option>
          </select>
        </div>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Dependent Relationship</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="relationship" required>
            <option value="">-- Please Select --</option>
            <option value="Spouse">Spouse</option>
            <option value="Child">Child</option>
          </select>
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        v-if="relationship && relationship == 'Child'"
      >
        <label class="col-md-3 mb-0">Is your child on full-time studies?</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="fullTime" required>
            <option value="">-- Please Select --</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Group Dental</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="groupDental" required>
            <option value="">-- Please Select --</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Group H&S and MM</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="groupHsmm" required>
            <option value="">-- Please Select --</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
      </div>
            
      <div class="row">
        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="fa fa-reply mr-2"></i>Back
          </button>
        </div>
        <div class="col-md-7 text-right">
          <button type="submit" class="btn btn-primary">
            <i v-if="$route.params.id" class="fa fa-save"></i>
            <i v-else class="fa fa-plus"></i>
            {{ $route.params.id ? "Save" : "Add" }}
          </button>
        </div>
      </div>
    </form>
    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Select2 from "v-select2-component";
export default {
  components: { Select2 },
  data() {
    return {
      employees: [],
      years: [],
      names: [],
      //form input
      userId: "",
      year: "",
      name: "",
      groupDental: "",
      groupHsmm: "",
      maritalStatus: "",
      relationship: "",
      ic: "",
      nationality: "",
      gender: "",
      birthday: "",
      birthdayDisplay: "",
      fullTime: "",
      loadingName: config.LOADING_EMPLOYEE_NAME,
      maritalStatus: "",
      isNewEmployee: false
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  watch: {
    userId(val) {
      if (!val) {
        this.names = [];
        return;
      }
      //if add mode, reset all value
      if (!this.$route.params.id) {
        this.ic = "";
        this.nationality = "";
        this.gender = "";
        this.birthday = "";
        this.birthdayDisplay = "";
        this.groupDental = "";
        this.groupHsmm = "";
        this.maritalStatus = "";
        this.relationship = "";
        this.fullTime = "";
      }
      this.getEmployeeDependentNames(val);
    },
  },

  methods: {
    getEmployees() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
            if (this.role == "employee") this.userId = this.employees[0].id;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;

            if ( this.isNewEmployee ) {
              this.year = response.data.record[0];

              // console.log("Dependent Year: " + this.year);
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployeeDependent() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeDependentDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) {
              let data = response.data.record;
              this.userId = data.UserId;
              this.year = data.Year;
              this.name = data.Name;
              this.groupDental = data.GroupDental ? "True" : "False";
              this.groupHsmm = data.GroupHSAndMM ? "True" : "False";
              this.maritalStatus = data.MaritalStatus;
              this.relationship = data.Relationship;
              this.ic = data.ICNumber;
              this.nationality = data.Nationality;
              this.gender = data.Gender;
              this.birthday = data.Birthday;
              this.birthdayDisplay = data.BirthdayDisplay;
              this.fullTime =
                data.ChildOnFullTimeStudy == null
                  ? ""
                  : data.ChildOnFullTimeStudy
                  ? "True"
                  : "False";
            } else {
              this.$router.replace({ name: "insuranceDependent" });
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployeeDependentNames(userId) {
      let param = { Token: this.token, Id: userId };
      this.$store.state.isLoading = true;
      API.getEmployeeDependentNames(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.names = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      //ic number validation for singaporean and malaysian
      //comment the IC validation as it is read-only data as of 28 Aug 2022
      /*let nationality = this.nationality.trim().toLowerCase();
      let isIcValid = true;
      if (nationality == "singaporean") {
        if (this.ic.trim().length != 9) isIcValid = false;
      } else if (nationality == "malaysian") {
        let icArray = this.ic.trim().split("-");
        if (icArray && icArray.length == 3) {
          if (icArray[0].length != 6) isIcValid = false;
          else if (icArray[1].length != 2) isIcValid = false;
          else if (icArray[2].length != 4) isIcValid = false;
        } else {
          isIcValid = false;
        }
      }
      if (!isIcValid) {
        this.$swal("Invalid IC Number", { icon: "error" });
        return;
      }*/

      //saving
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        UserId: this.role == "admin" ? this.userId : this.employees[0].id,
        Year: this.year,
        Name: this.name,
        GroupDental: this.groupDental,
        GroupHsmm: this.groupHsmm,
        MaritalStatus: this.maritalStatus,
        Relationship: this.relationship,
        Ic: this.ic,
        Nationality: this.nationality,
        Gender: this.gender,
        BirthdayInput: this.birthday,
        FullTime: this.fullTime,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveEmployeeDependent(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.$router.replace({ name: "insuranceDependent" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    onChangeDependentName(event) {
      //only for adding new dependent
      //if (!this.$route.params.id) {
        let name = event.target.value;
        if (!name) {
          this.ic = "";
          this.nationality = "";
          this.gender = "";
          this.birthday = "";
        } else {
          let param = {
            Token: this.token,
            UserId: this.role == "admin" ? this.userId : this.employees[0].id,
            Name: name,
          };
          this.$store.state.isLoading = true;
          API.getEmployeeDependentDetailByName(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              if (response.data.success) {
                let data = response.data.record;
                this.ic = data.Ic;
                this.nationality = data.Nationality;
                this.gender = data.Gender;
                this.birthday = data.BirthdayCalendar;
                this.birthdayDisplay = data.BirthdayDisplay;
              } else {
                this.$swal(response.data.message, { icon: "error" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
        this.groupDental = "";
        this.groupHsmm = "";
        this.relationship = "";
        this.fullTime = "";
      //}
    },
  },

  created() {
    if (this.role == "employee") {
      API.getEnrolmentPeriod({
        Token: this.token,
        Type: "Insurance",
        EmployeeDependentId: this.$route.params.id,
      })
        .then((response) => {
          if (response.data.success) {
            if (!response.data.isEnrolmentOpen && !response.data.isNewEmployee) {
              this.$router.replace({ name: "insuranceDependent" });
              return;
            }

            if ( response.data.isNewEmployee ) {
              this.isNewEmployee = response.data.isNewEmployee;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }

          this.getYears();
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });

        this.getYears();
        this.getEmployees();

        if (this.$route.params.id) this.getEmployeeDependent(); //for edit mode
    }
    else {
      this.getYears();
      this.getEmployees();

      if (this.$route.params.id) this.getEmployeeDependent(); //for edit mode
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Insurance/InsuranceAndDependent/DependentEdit.vue